<template>
    <div>
      <div v-if="image && !showImage" @click="showImage = true" class="relative">
          <div class="preview-img">
              <img class="img-fluid" :src="getUrlImage(image)" />
          </div>
          <div class="fade-img">
              <p class="m-show">Expandir imagem</p>
              <p class="hidden">Expandir imagem</p>
          </div>
      </div>
      <upload-image v-else ref="upimg" :environment="environment" :maxWidth="512" :maxHeight="512" :label="'Enviar imagem'" @setImage="sendImage" class="mb_15">
        <div v-if="!image" class="no-img">
          <i class="fal fa-image-polaroid"></i>
        </div>
        <div v-else class="with-img text-center mb-20 relative">
          <img class="img-fluid w-100" :src="getUrlImage(image)" />
          <div class="d-flex py_10 mt_5 mb_15">
              <base-button text="Retrair" @click="showImage = false" design="four"  class="w-100 mr_10"/>
              <base-button text="Alterar" @setImage="sendImage" design="four"  class="w-100 ml_5 mr_5"/>
              <base-button type="button"  @click.stop="deleteImage" text="Excluir" design="four"  class="w-100 ml_10"/>
          </div>
        </div>
      </upload-image>
    </div>
</template>
<script>
import UploadImage from "@/containers/UploadImage"
import { getXAPIEnv } from '@/plugins/account'

import BaseButton from '@/components/Button'

export default {
    data() {
        return {
            urlImage: `${process.env.VUE_APP_IMAGES}/${getXAPIEnv()}`,
            showImage: false,
        }
    },
    props: {
        image: {required: true}
    },
    watch: {
      image: {
        deep: true,
        handler(newV) {
            this.$forceUpdate();
        }
      },
    },
    methods: {
      getUrlImage(image) {
        if (image.indexOf(process.env.VUE_APP_IMAGES_DEFAULT) !== -1) {
          return image;
        }

        return `${this.urlImage}/${image}`
      },
        sendImage(fileName){
            this.$emit('setImage', fileName)
        },
        deleteImage() {
          this.showImage = false
          this.$emit("setImage", null);
        },
    },
    components: {
        UploadImage,
        BaseButton,
    },
    computed: {
        environment() {
            return getXAPIEnv();
        },
    },
}
</script>
<style scoped>
    .no-img {
      background: linear-gradient(45deg, #292a2d, #292a2d);
      width: 100%;
      font-weight: bold;
      border: 2px dashed #656565c7;
      border-radius: 5px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      font-size: 1.8em;
      padding: 55px;
      color: #575758;
      cursor: pointer;
      transition: filter 0.2s ease-in-out;
    }

    .two .no-img {
      background: #3a3c40;
      color: #5a5b5c;
    }

    .no-img:hover {
      filter: brightness(1.1);
    }

  .preview-img{
    width: 100%;
    height: 150px;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    border-radius: 5px;
    margin-bottom: 25px;
  }
  .preview-img img{
      width: 100%;
      height: auto;
      opacity: .9;
  }
  .fade-img{
      width: 100%;
      height: 100%;
      background-color: rgba(0,0,0,0.4);
      position: absolute;
      top: 0;
      left: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      border-radius: 5px;
  }
  .fade-img:hover{
      background-color: rgba(0,0,0,0.3);
  }
  .fade-img.no-hover{
      background-color: rgba(0,0,0,0.2);
      cursor: default;
  }
  .fade-img p.m-show, .fade-img:hover p:not(.m-show){
      display: block;
      font-size: 1.4em;
      font-weight: 600;
      color: rgba(255, 255, 255, .8);
  }
  .with-img{
      overflow: hidden;
      border-radius: 5px;
  }
  .change-img{
      position: absolute;
      right: 0;
      bottom: 0;
      padding: 10px 20px;
      border-radius: 5px 0 5px 0;
      font-size: 1.3em;
      color: white;
      font-weight: 600;
      cursor: pointer;
  }
</style>
